import { useApiRequest } from "@hooks/use-api-request";
import { useMutation } from "@tanstack/react-query";

export const useDownloadPathwayPdf = () => {
  const mutationFn = useApiRequest({
    url: "/reports/user-pathway",
    responseType: "blob",
  });

  return useMutation({
    mutationKey: ["download-pathway-pdf"],
    mutationFn: (id) => mutationFn({ params: { career_plan_id: id } }),
  });
};
